// extracted by mini-css-extract-plugin
export var image = "image-module--image--3mjU-";
export var description = "image-module--description--1ACMv";
export var image__pull_left = "image-module--image__pull_left--3_gJW";
export var image__pull_right = "image-module--image__pull_right--3ah_M";
export var image__full = "image-module--image__full--3HL-a";